import React from "react";
import { ArcElement, Chart as ChartJS, Tooltip } from "chart.js";
import { Doughnut } from "react-chartjs-2";

import CustomBox from "../../../../../Components/UI/CustomBox/CustomBox/CustomBox";

import "./styles.scss";

ChartJS.register(ArcElement, Tooltip);

const RiskScoreGauge = ({ riskScore }) => {
  if (riskScore === undefined || riskScore === null || isNaN(riskScore)) {
    return (
      <CustomBox className="thunter-risk-score border">
        <h2 className="thunter-risk-score__title">Risk Score</h2>
        <div className="thunter-risk-score__chart">
          <div className="thunter-risk-score__value">N/A</div>
        </div>
        <div className="thunter-risk-score__text">
          <p className="thunter-risk-score__label">Risk Level Interpretation</p>
          <p className="thunter-risk-score__level">Unavailable</p>
          <p className="thunter-risk-score__detail">No score provided for analysis.</p>
        </div>
      </CustomBox>
    );
  }

  const verdictColor = riskScore > 110 ? "#d32f2f" : riskScore > 30 ? "#f57c00" : "#388e3c";

  const normalizedScore = Math.min(Math.max(riskScore, 0), 100);

  const gaugeData = {
    labels: ["Risk Score"],
    datasets: [
      {
        data: [normalizedScore, 100 - normalizedScore],
        backgroundColor: [verdictColor, "#2e2e2e"],
        borderWidth: 0,
        circumference: 180,
        rotation: 270,
        cutout: "70%",
      },
    ],
  };

  const gaugeOptions = {
    plugins: {
      tooltip: { enabled: false },
      legend: { display: false },
    },
    cutout: "70%",
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <CustomBox className="thunter-risk-score border">
      <h2 className="thunter-risk-score__title">Risk Score</h2>

      <div className="thunter-risk-score__chart">
        <Doughnut data={gaugeData} options={gaugeOptions} />
        <div className="thunter-risk-score__value" style={{ color: verdictColor }}>
          {riskScore.toFixed(1)}
        </div>
      </div>

      <div className="thunter-risk-score__text">
        <p className="thunter-risk-score__label">Risk Level Interpretation</p>
        <p className="thunter-risk-score__level" style={{ color: verdictColor }}>
          {riskScore > 110 ? "High Risk" : riskScore > 30 ? "Medium Risk" : "Low Risk"}
        </p>
        <p className="thunter-risk-score__detail">
          {riskScore > 50
            ? "Immediate action recommended"
            : riskScore > 30
            ? "Further investigation needed"
            : "Monitor system activity"}
        </p>
      </div>
    </CustomBox>
  );
};

export default RiskScoreGauge;
